import axiosService from "@/modules/axios-service";

class KhCalculatorService {
  path = "/pricing";
  accountOpeningClickPath = "/kh-calculator/account-opening-link/click";
  constructor(path = undefined) {
    if (path) {
      this.path = path;
    }
  }

  replaceNullsWithZero(value) {
    if (value === null) return 0;
    if (value === "") return 0;
    if (Array.isArray(value)) {
      return value.map(v => this.replaceNullsWithZero(v));
    }

    if (value !== null && typeof value === "object") {
      const result = {};
      Object.keys(value).forEach(key => {
        result[key] = this.replaceNullsWithZero(value[key]);
      });
      return result;
    }

    return value;
  }


  buildRequestBody(requestBody = {}, extraFields = {}) {
    const base = requestBody || {};

    const merged = {
      ...base,
      ...extraFields,
    };

    return this.replaceNullsWithZero(merged);
  }

  calculateCost(accountId, requestBody = null) {
    const path = this.path +
      "/" +
      accountId +
      "/calculate"

    // const response = {
    //   accountId: "acc-123",
    //   cardFee: 1450,
    //   accountFee: 1600,
    //   transferFees: 2300,
    //   recurringTransferFee: 3200,
    //   groupDirectDebitFee: 1400,
    //   cashWithdrawalFee: 4450,
    //   otherFees: 800,
    //   inputOverrides: {
    //     monthlyIncome: 450000,
    //     smsCount: 12,
    //   },
    //   currentAccountCost: 33000,
    //   resultsByPackage: {
    //     ALAP: {
    //       package: "ALAP",
    //       monthlyFeeHUF: 1690,
    //       discountsApplied: ["sms"],
    //       cardFee: 2200,
    //       accountFee: 1600,
    //       transferFees: 2300,
    //       recurringTransferFee: 3200,
    //       groupDirectDebitFee: 1400,
    //       cashWithdrawalFee: 400,
    //       otherFees: 800,
    //       totalCost: 2400,
    //     },
    //     KENYELMI_PLUSZ: {
    //       package: "KENYELMI_PLUSZ",
    //       monthlyFeeHUF: 2490,
    //       cardFee: 1200,
    //       accountFee: 1600,
    //       transferFees: 2300,
    //       recurringTransferFee: 32040,
    //       groupDirectDebitFee: 1400,
    //       cashWithdrawalFee: 4065,
    //       otherFees: 800,
    //       totalCost: 2600,
    //     },
    //     KENYELMI_PLUSZ_ONLINE: {
    //       package: "KENYELMI_PLUSZ_ONLINE",
    //       monthlyFeeHUF: 2190,
    //       cardFee: 1200,
    //       accountFee: 1600,
    //       transferFees: 2300,
    //       recurringTransferFee: 200,
    //       groupDirectDebitFee: 1400,
    //       cashWithdrawalFee: 500,
    //       otherFees: 800,
    //       totalCost: 0,
    //     },
    //     PREMIUM: {
    //       package: "PREMIUM",
    //       monthlyFeeHUF: 3990,
    //       cardFee: 1200,
    //       accountFee: 1600,
    //       transferFees: 2300,
    //       recurringTransferFee: 3200,
    //       groupDirectDebitFee: 1400,
    //       cashWithdrawalFee: 440,
    //       otherFees: 800,
    //       totalCost: 2500,
    //     },
    //   }
    // };

    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(response);
    //   }, 5000);
    // });

    if (requestBody === null) {
      return axiosService.post(path, {});
    }

    const extraFields = {
      monthsSinceOpen: 0,
      monthlyIncome: 0,
      savingsEndOfPrevMonth: 0,
      cardSpend: 0,
      regularInvestment: 0,
      hasFeeBasedLifeInsurance: false,
      lifeAddon: "NONE",
      hasStatutoryDecl: false,
      smsCount: 0,
    };

    const bodyToSend = this.buildRequestBody(requestBody, extraFields);
    return axiosService.post(path, bodyToSend);
  }

  recordKhAccountOpeningLinkClick() {
    return axiosService.post(this.accountOpeningClickPath);
  }
}

export default new KhCalculatorService();
